import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation, Scrollbar, A11y, EffectFade, Autoplay } from 'swiper/modules';
import { Modal, message } from 'antd';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import jobsData from './AvalableJob.json';

const GAS_ENDPOINT = 'https://script.google.com/macros/s/AKfycbxclQ4bFgqSZ8ePKPfFjC7DeCXCA3HHYpcXuWqps0PKB4wHol9AJJHn-D6-OkFa75MlOg/exec';

function TeamTwo() {
    const [selectedJob, setSelectedJob] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    console.log(process.env.GOOGLE_SCRIPT_LINK);

    // ► STATE pentru formular
    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        cv: null,
        applyWithoutCV: false,
    });

    // ► Handlere
    const handleJobClick = (job) => setSelectedJob(job);
    const handleCloseModal = () => {
        setSelectedJob(null);
        setForm({ name: '', email: '', phone: '', message: '', cv: null, applyWithoutCV: false });
        setIsLoading(false);
    };
    const handleChange = (e) => {
        const { name, value, files, type, checked } = e.target;
        
        if (name === 'applyWithoutCV') {
            // Gestionare specială pentru checkbox
            console.log('Checkbox clicked:', checked);
            setForm((prev) => ({ ...prev, [name]: checked }));
            // Dacă se bifează "fără CV", resetăm CV-ul
            if (checked) {
                setForm((prev) => ({ ...prev, cv: null }));
                // Resetăm și input-ul file
                const fileInput = document.querySelector('input[name="cv"]');
                if (fileInput) fileInput.value = '';
            }
        } else if (name === 'cv' && files && files[0]) {
            const file = files[0];
            
            // Verificăm dacă este PDF
            if (file.type !== 'application/pdf') {
                message.error('Vă rugăm să încărcați doar fișiere PDF.');
                e.target.value = ''; // Resetăm input-ul
                return;
            }
            
            // Verificăm dimensiunea (20 MB = 20 * 1024 * 1024 bytes)
            const maxSize = 20 * 1024 * 1024; // 20 MB în bytes
            if (file.size > maxSize) {
                message.error('Fișierul este prea mare. Dimensiunea maximă permisă este 20 MB.');
                e.target.value = ''; // Resetăm input-ul
                return;
            }
            
            setForm((prev) => ({ ...prev, [name]: file }));
            // Dacă se încarcă un CV, debifăm "fără CV"
            setForm((prev) => ({ ...prev, applyWithoutCV: false }));
        } else {
            setForm((prev) => ({ ...prev, [name]: files ? files[0] : value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        try {
            // Verificăm dacă aplicăm fără CV
            if (form.applyWithoutCV) {
                // Aplicare fără CV
                const data = new FormData();
                data.append('name', form.name);
                data.append('email', form.email);
                data.append('phone', form.phone);
                data.append('message', form.message || '');
                data.append('jobTitle', selectedJob.title);
                data.append('jobLocation', selectedJob.location);
                data.append('withoutCV', 'true');

                const response = await fetch(GAS_ENDPOINT, { 
                    method: 'POST', 
                    body: data,
                    mode: 'no-cors'
                });

                console.log('Response status:', response.status);

                if (response.type === 'opaque' || response.status === 0 || response.ok) {
                    message.success('Aplicația a fost trimisă cu succes!');
                    handleCloseModal();
                } else {
                    console.error('Response not OK:', response.status, response.statusText);
                    message.error('Eroare la trimitere. Încearcă din nou.');
                    setIsLoading(false);
                }
            } else {
                // Aplicare cu CV (logica existentă)
                const file = form.cv;
                const reader = new FileReader();
                reader.onloadend = async () => {
                    try {
                        const base64 = reader.result.split(',')[1];

                        const data = new FormData();
                        data.append('filename', file.name);
                        data.append('mimeType', file.type || 'application/octet-stream');
                        data.append('fileData', base64);
                        data.append('name', form.name);
                        data.append('email', form.email);
                        data.append('phone', form.phone);
                        data.append('message', form.message || '');
                        data.append('jobTitle', selectedJob.title);
                        data.append('jobLocation', selectedJob.location);

                        const response = await fetch(GAS_ENDPOINT, { 
                            method: 'POST', 
                            body: data,
                            mode: 'no-cors'
                        });

                        console.log('Response status:', response.status);

                        if (response.type === 'opaque' || response.status === 0 || response.ok) {
                            message.success('Aplicația a fost trimisă cu succes!');
                            handleCloseModal();
                        } else {
                            console.error('Response not OK:', response.status, response.statusText);
                            message.error('Eroare la trimitere. Încearcă din nou.');
                            setIsLoading(false);
                        }
                    } catch (err) {
                        console.error('Fetch error:', err);
                        message.error('Eroare la trimitere. Încearcă din nou.');
                        setIsLoading(false);
                    }
                };
                reader.readAsDataURL(file);
            }
        } catch (err) {
            console.error('File reading error:', err);
            message.error('Eroare la citirea fișierului. Încearcă din nou.');
            setIsLoading(false);
        }
    };

    return (
        <div>
            {/* rts team two area */}
            <div className="rts-team-area rts-section-gap team-two">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="rts-title-area team text-center">
                                <p className="pre-title">Professionals Team</p>
                                <h2 className="title">Professionals Team</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row g-5 mt--20 mt_md--30 mt_sm--0">
                        <div className="swiper">
                            <Swiper
                                // install Swiper modules
                                modules={[Navigation, EffectFade, Scrollbar, A11y, Autoplay]}
                                className="swiper mySwiperh3_team pb--110 pl--20 pr--20"
                                speed={200}
                                slidesPerView={3}
                                spaceBetween={30}
                                loop={true}
                                autoplay={true}
                                navigation={{
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                }}
                                breakpoints={{
                                    1200: { slidesPerView: 3 },
                                    900: { slidesPerView: 2 },
                                    768: { slidesPerView: 2 },
                                    580: { slidesPerView: 1.5 },
                                    450: { slidesPerView: 1.2 },
                                    0: { slidesPerView: 1.1 },
                                }}
                            >
                                {jobsData.map((job) => (
                                    <SwiperSlide key={job.id}>
                                        {/* single team inner */}
                                        <div className="team-inner-two">
                                            <div className='h-[300px] w-auto rounded-xxl text-2xl hover:scale-105 transition-all duration-300 cursor-pointer' onClick={() => handleJobClick(job)}>
                                                <div className={`bg-image h-full w-full rounded-md relative`} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/${job.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                                                    {/* Overlay galben */}
                                                    <div className="absolute inset-0 bg-yellow-400 bg-opacity-80 rounded-md"></div>
                                                    {/* Titlu poziționat pe overlay */}
                                                    <div className="absolute inset-0 flex justify-center items-center">
                                                        <h3 className='font-extrabold text-black text-3xl md:text-4xl text-center px-4 drop-shadow-lg'>
                                                            {job.title}
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Acquaintance area */}
                                            <div className="acquaintance-area flex flex-col items-center justify-center bg-white rounded-xl shadow-lg p-6 pt-8 mt-[-40px] mx-auto w-[320px] min-h-[120px] z-10 relative">
                                                <span className='text-gray-700 text-lg mb-4 text-center'>{job.location}</span>
                                                <button className='bg-[#ffde21] text-black px-6 py-2 rounded-md font-semibold text-lg shadow hover:bg-yellow-300 transition' onClick={() => handleJobClick(job)}>Aplică</button>
                                            </div>
                                            {/* Acquaintance area */}
                                        </div>
                                        {/* single team inner End */}
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
            {/* rts team two area End */}

            {selectedJob && (
                <Modal
                    open={!!selectedJob}
                    onCancel={handleCloseModal}
                    footer={null}
                    width={600}
                >   
                    <div className='p-2 sm:p-4' style={{ fontFamily: 'DM Sans, sans-serif' }}>
                        <h3 className='text-2xl font-bold mb-2 text-center'>{selectedJob.title}</h3>
                        <div className='flex flex-wrap justify-center gap-4 mb-4'>
                            <span className='bg-yellow-100 text-yellow-800 px-3 py-1 rounded text-sm font-semibold'>{selectedJob.type}</span>
                            <span className='bg-gray-100 text-gray-800 px-3 py-1 rounded text-sm'>{selectedJob.location}</span>
                            <span className='bg-green-100 text-green-800 px-3 py-1 rounded text-sm font-semibold'>{selectedJob.salary}</span>
                        </div>
                        <p className='text-gray-700 mb-4 text-center'>{selectedJob.shortDescription}</p>
                        <div className='mb-2'>
                            <h4 className='font-semibold mb-1 text-3xl py-4'>Responsabilități:</h4>
                            <ul className='list-disc list-inside text-gray-600 leading-tight space-y-1'>
                                {selectedJob.responsibilities && selectedJob.responsibilities.map((item, idx) => (
                                    <li className='text-[14px]' key={idx}>{item}</li>
                                ))}
                            </ul>
                        </div>
                        <div className='mb-2'>
                            <h4 className='font-semibold mb-1 text-3xl py-4'>Cerințe:</h4>
                            <ul className='list-disc list-inside text-gray-600 leading-tight space-y-1'>
                                {selectedJob.requirements && selectedJob.requirements.map((item, idx) => (
                                    <li className='text-[14px]' key={idx}>{item}</li>
                                ))}
                            </ul>
                        </div>
                        <div className='mb-2'>
                            <h4 className='font-semibold mb-1 text-3xl py-4'>Beneficii:</h4>
                            <ul className='list-disc list-inside text-gray-600 leading-tight space-y-1'>
                                {selectedJob.benefits && selectedJob.benefits.map((item, idx) => (
                                    <li className='text-[14px]' key={idx}>{item}</li>
                                ))}
                            </ul>
                        </div>
                        <div className='mb-2'>
                            <h4 className='font-semibold mb-1 text-3xl py-4'>Condiții de lucru:</h4>
                            <ul className='list-disc list-inside text-gray-600 leading-tight space-y-1'>
                                {selectedJob.workConditions && selectedJob.workConditions.map((item, idx) => (
                                    <li className='text-[14px]' key={idx}>{item}</li>
                                ))}
                            </ul>
                        </div>
                        <div className='mb-2'>
                            <h4 className='font-semibold mb-1 text-3xl py-4'>Informații suplimentare:</h4>
                            <p className='text-gray-600 text-[14px]'>{selectedJob.additionalInfo}</p>
                        </div>
                        <hr className='my-4' />
                        <form onSubmit={handleSubmit} className='flex flex-col gap-3'>
                            <h4 className='font-bold text-lg mb-2 text-center'>Aplică pentru acest post</h4>
                            <input 
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                type='text' 
                                placeholder='Nume și prenume' 
                                className='border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400' 
                                required 
                                disabled={isLoading}
                            />
                            <input 
                                name="email"
                                type="email"
                                value={form.email}
                                onChange={handleChange}
                                placeholder='Email' 
                                className='border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400' 
                                required 
                                disabled={isLoading}
                            />
                            <input 
                                name="phone"
                                value={form.phone}
                                onChange={handleChange}
                                type='tel' 
                                placeholder='Telefon' 
                                className='border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400' 
                                required 
                                disabled={isLoading}
                            />
                            <input 
                                name="cv"
                                type='file' 
                                onChange={handleChange}
                                className='border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400' 
                                accept='.pdf'
                                required={!form.applyWithoutCV}
                                disabled={isLoading || form.applyWithoutCV}
                            />
                            <p className="text-xs text-gray-500 mt-1">
                                Doar fișiere PDF. Dimensiunea maximă: 20 MB
                            </p>
                            
                            <div className="flex items-center gap-2 mt-3">
                                <input 
                                    id="applyWithoutCV"
                                    name="applyWithoutCV"
                                    type="checkbox"
                                    checked={form.applyWithoutCV}
                                    onChange={handleChange}
                                    className="w-4 h-4 text-yellow-400 focus:ring-yellow-400 border-gray-300 rounded"
                                    disabled={isLoading}
                                />
                                <label htmlFor="applyWithoutCV" className="text-sm text-gray-700 cursor-pointer">
                                    Aplică fără CV (voi trimite CV-ul ulterior)
                                </label>
                            </div>
                            <textarea 
                                name="message"
                                value={form.message}
                                onChange={handleChange}
                                placeholder='Mesaj (opțional)' 
                                className='border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400 resize-none' 
                                rows={3}
                                disabled={isLoading}
                            />
                            <button 
                                type='submit' 
                                className={`font-semibold rounded px-4 py-2 mt-2 transition flex items-center justify-center gap-2 ${
                                    isLoading 
                                        ? 'bg-gray-400 text-gray-600 cursor-not-allowed' 
                                        : 'bg-[#ffde21] text-black hover:bg-yellow-300'
                                }`}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600"></div>
                                        Se trimite...
                                    </>
                                ) : (
                                    'Trimite aplicația'
                                )}
                            </button>
                        </form>
                    </div>
                </Modal>
            )}
            
        </div>
    )
}

export default TeamTwo